export const AUTHORIZATION_HEADER_PREFIX = "Bearer"
